export default __webpack_public_path__ + "static/media/Lomenox.4eef41b1.jpeg";